
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tyres/pickup/dodge-ram",
      function () {
        return require("private-next-pages/tyres/pickup/dodge-ram.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tyres/pickup/dodge-ram"])
      });
    }
  